export const PointLoyaltyTransation = (json: IPointLoyaltyTransaction): IPointLoyaltyTransactionModel => {
	const {
		loyalty_point_id,
		transactionable_id,
		transactionable_type,
		loyalty_activity,
		loyalty_activity_id,
		loyalty_point,
		points_balance,
		updated_at,
		created_at,
		...rest
	} = json

	return {
		...rest,
		loyaltyPointId: loyalty_point_id,
		loyaltyPoint: PointLoyaltyPoint(loyalty_point),
		transactionableId: transactionable_id,
		transactionableType: transactionable_type,
		loyaltyActivity: PointsLoyaltyActivity(loyalty_activity),
		loyaltyActivityId: loyalty_activity_id,
		pointsBalance: points_balance,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}
